export default __webpack_public_path__ + "static/media/business.715e189c.svg";